import React, { useState } from 'react';
import { FadeIn } from './ui/FadeIn';
import { ChevronDown } from 'lucide-react';
import { cn } from '../lib/utils';
export const FAQ = () => {
  const faqs = [{
    q: 'Чи це анонімно?',
    a: 'Так, ми гарантуємо 100% анонімність. Ми не ставимо пацієнтів на наркологічний облік, не передаємо дані за місцем роботи чи в державні установи. Бригада приїжджає на автомобілі без розпізнавальних знаків.'
  }, {
    q: 'Скільки коштує виклик лікаря?',
    a: 'Вартість залежить від стану пацієнта, необхідних медикаментів та тривалості процедур. Базовий виклик з крапельницею починається від фіксованої суми. Точну ціну лікар озвучує після огляду до початку маніпуляцій.'
  }, {
    q: 'Як швидко приїде лікар?',
    a: 'По місту бригада прибуває протягом 30–60 хвилин після виклику. Ми працюємо цілодобово, без вихідних та святкових днів.'
  }, {
    q: 'Що робити при сильному запої?',
    a: 'Не намагайтеся різко обірвати запій самостійно, це може призвести до важких ускладнень (біла гарячка, інсульт). Негайно викличте нарколога. До приїзду лікаря забезпечте пацієнту спокій та давайте багато пити звичайної води.'
  }, {
    q: 'Чи можна лікуватись вдома?',
    a: 'Так, вивід із запою та зняття похмільного синдрому можна провести вдома, якщо стан пацієнта не є критичним. Однак повноцінне лікування залежності (кодування, реабілітація) ефективніше проводити в умовах стаціонару.'
  }];
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  return <section className="py-24 bg-white" data-id="element-15">
      <div className="container mx-auto px-4 md:px-6 max-w-4xl" data-id="element-16">
        <FadeIn data-id="element-17">
          <h2 className="text-3xl md:text-5xl font-bold mb-12 text-center" data-id="element-18">
            Часті запитання
          </h2>
        </FadeIn>

        <div className="space-y-4" data-id="element-19">
          {faqs.map((faq, idx) => <FadeIn key={idx} delay={idx * 0.1} data-id="element-20">
              <div className="border border-gray-200 bg-white overflow-hidden transition-colors hover:border-gray-300" data-id="element-21">
                <button className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenIdx(openIdx === idx ? null : idx)} data-id="element-22">
                  <span className="font-bold text-lg pr-8" data-id="element-23">{faq.q}</span>
                  <ChevronDown className={cn('w-5 h-5 text-gray-400 transition-transform duration-300 flex-shrink-0', openIdx === idx ? 'rotate-180' : '')} data-id="element-24" />
                </button>
                <div className={cn('px-6 overflow-hidden transition-all duration-300 ease-in-out', openIdx === idx ? 'max-h-96 pb-6 opacity-100' : 'max-h-0 opacity-0')} data-id="element-25">
                  <p className="text-gray-600 leading-relaxed pt-2 border-t border-gray-100" data-id="element-26">
                    {faq.a}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
};